import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
function ErrorSection(props) {
  const { btnTitle, btnAction } = props;
  const {t} = useTranslation();
  let navigate = useNavigate();
  return (
    <section className="error-box">
        <img src="/images/finwell-img/NoSearchResults.svg" alt="not found" width={248} height={251} className="img-fluid" />
      <div className="error-msgs">{t("Nothing here, yet.")}</div>
      <div className="button-design d-flex justify-content-center">
        <button type="button" className="startcourse-btn" onClick={()=> btnAction? navigate("/learn/group-workshops") : ""}>
          {btnTitle ? btnTitle : t("Explore courses")}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
              stroke="#415385"
              strokeWidth="1.66667"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
        </button>
      </div>
    </section>
  );
}

export default ErrorSection;
